export const _apiServer = "https://cms.houseofyards.com";
export const _api_host = "https://api.houseofyards.com";
export const _bam_host = "https://secure.houseofyards.com/#";
export const _bpm_host = "https://service-information-sample-only.houseofyards.com";
export const _bpm_domain = "houseofyards.com";